// extracted by mini-css-extract-plugin
module.exports = {"root":"L_bx","error":"L_b"};